<template>
  <b-container>
      <b-card>
        <b-row class="m-0 mt-2">
          <b-col
            lg="12">
            <validation-observer
              ref="requestForm">
              <b-form
                class="mb-1 mt-2"
                @submit.prevent="saveForm">
                <!-- Formulário de Incidente -->

                <h4 class="mt-2 mb-2">{{_.get(dataForm, 'type_form_str', '')}}</h4>
                <vs-divider></vs-divider>

                <!-- coup attempt type -->
                <RequestFormIncidentCoupAttempt v-if="typeForm === 'CA'"
                      :typeForm="typeForm"
                      :dataForm="dataForm"
                      :disabledFields="disabledFields"
                      ref="coupAttempt"/>

                <!-- general type -->
                <RequestFormIncidentGeneral v-if="typeForm === 'GE'"
                  :typeForm="typeForm"
                  :dataForm="dataForm"
                  :disabledFields="disabledFields"
                  ref="general"/>

                <div class="vx-row pt-2">
                  <div class="vx-col">
                    <b-form-group
                      :label="$t('incident_form_attachments')"
                      label-for="incident_form_attachments">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('incident_form_attachments')">
                        <b-form-file
                          id="attachments"
                          placeholder="Clique para selecionar os arquivos ou arraste aqui..."
                          drop-placeholder="Solte os arquivos aqui..."
                          v-model="newGeneralAttachments"
                          :state="errors.length > 0 ? false:null"
                          name="generalAttachments"
                          :disabled="disabledFields"
                          multiple
                          accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                          @input="appendGeneralAttachments"/>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small class="form-text text-muted">
                          <i class="feather icon-upload mr-1"></i>
                          Selecione um ou mais arquivos para anexar. Todos os anexos sao opcionais.
                        </small>
                        <div v-if="generalAttachments && generalAttachments.length" class="mt-2">
                          <b-list-group>
                            <b-list-group-item
                              v-for="(file, idx) in generalAttachments"
                              :key="`${getFileName(file)}-${idx}`"
                              class="d-flex justify-content-between align-items-center">
                              <div>
                                <i class="feather icon-file-text text-primary mr-2"></i>
                                <a
                                  v-if="getDownloadUrl(file)"
                                  :href="getDownloadUrl(file)"
                                  target="_blank"
                                  class="mr-2 download-link text-primary"
                                  title="Baixar arquivo">
                                  <i class="feather icon-download"></i>
                                </a>
                                <strong>{{ getFileName(file) }}</strong>
                                <small class="ml-2 text-muted" v-if="getFileSize(file)">
                                  ({{ formatFileSize(getFileSize(file)) }})
                                </small>
                              </div>
                              <b-button
                                v-if="!disabledFields"
                                variant="outline-danger"
                                size="sm"
                                @click="removeAttachment(idx)">
                                <i class="feather icon-trash-2"></i>
                              </b-button>
                            </b-list-group-item>
                          </b-list-group>
                        </div>
                      </validation-provider>
                    </b-form-group>
                  </div>
                </div>

                <!-- Actions -->
                <div class="mt-1 mb-2">
                  <div class="flex justify-end">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="mt-1 mr-1 float-right"
                      :disabled="!validateForm"
                      v-if="!disabledFields"
                      @click="saveForm()">
                        {{$t('save')}}
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-secondary"
                      class="mt-1 mr-1 float-right"
                      @click="$router.push('/incident-form')">
                        {{$t('back')}}
                    </b-button>
                  </div>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import {
  BContainer,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadio,
  BFormRadioGroup,
  BFormTextarea,
  BFormSelect,
  BFormSelectOption,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  BFormFile,
  BListGroup,
  BListGroupItem,
  VBTooltip,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

//Services
import RequestFormIncidentService from '@/services/api/incident/RequestFormIncidentService'
import RequestFormIncidentHandlingService from '@/services/api/incident/RequestFormIncidentHandlingService'

//Components
import RequestFormIncidentCoupAttempt from '../RequestFormIncidentCoupAttempt'
import RequestFormIncidentGeneral from '../RequestFormIncidentGeneral'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Datepicker,
    vSelect,
    BContainer,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    BCard,
    BTable,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    BFormFile,
    BListGroup,
    BListGroupItem,
    VBTooltip,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    //
    RequestFormIncidentCoupAttempt,
    RequestFormIncidentGeneral,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    dataForm : null,
    legalEntityList: [],
    generalAttachments: [],
    newGeneralAttachments: [],

    services: {
      requestFormIncidentService: null,
    },
  }),
  methods: {
    saveForm(){
      this.$refs.requestForm.validate().then(success => {
        if (success) {
          this.clearErrors(this.$refs.requestForm)
          this.confirmEdit()
        }else{
          console.log('error!', success)
          this.errorAlertFormValidaded()
        }
      },
      error => {
        console.log('error: ', error)
      })
    },
    confirmEdit(){
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Confirmação',
          acceptText: 'Sim',
          cancelText: 'Não',
          text: this.$t('confirmacao_edita_form_'),
          accept: () => {
            this.save()
          }
        })
    },
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const params = this.getDataFields()
      const formData = this.buildFormData(params)

      this.services.requestFormIncidentHandlingService.updateRequestFormIncident(this.id, this.dataForm.id, formData)
        .then(
          data => {
            this.$vs.loading.close()
            this.sucessNotify()
          },
          error => {
            this.showErrors(this.$validator, error)
          }
        )
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getDataFields(){
      const params = {
        typeForm: this.typeForm,
        id: this.dataForm.id
      }
      // Encapsular dados dos componentes filhos
      let data_form = {};
      if (this.typeForm === 'CA' && this.$refs.coupAttempt) {
        data_form = this.$refs.coupAttempt.getFormData();
      } else if (this.typeForm === 'GE' && this.$refs.general) {
        data_form = this.$refs.general.getFormData();
      }
      return {
        ...params,
        data_form: data_form
      };
    },
    buildFormData(params) {
      const formData = new FormData()
      formData.append('_method', 'PUT')
      formData.append('typeForm', params.typeForm)
      formData.append('id', String(params.id))

      const dataFormObj = {}
      if (params.data_form) {
        Object.keys(params.data_form).forEach(key => {
          const value = params.data_form[key]

          if (Array.isArray(value)) {
            const uploadedFiles = value.filter(item => item instanceof File)
            if (uploadedFiles.length) {
              uploadedFiles.forEach(file => formData.append(`${key}[]`, file))
              return
            }
          } else if (value instanceof File) {
            formData.append(`${key}[]`, value)
            return
          }

          dataFormObj[key] = value
        })
      }

      if (this.generalAttachments && this.generalAttachments.length) {
        this.generalAttachments
          .filter(file => file instanceof File)
          .forEach(file => formData.append('generalAttachments[]', file))
      }

      formData.append('data_form', JSON.stringify(dataFormObj))
      return formData
    },
    appendGeneralAttachments(files) {
      if (!files) {
        this.newGeneralAttachments = []
        return
      }

      const list = Array.isArray(files) ? files : [files]
      const freshFiles = list.filter(file => file instanceof File)
      if (freshFiles.length) {
        this.generalAttachments = [...this.generalAttachments, ...freshFiles]
      }
      this.newGeneralAttachments = []
    },
    getFileName(file) {
      return _.get(file, 'file_name') || _.get(file, 'name') || 'Arquivo'
    },
    getFileSize(file) {
      return _.get(file, 'size') || _.get(file, 'custom_properties.size') || null
    },
    formatFileSize(size) {
      if (!size) return null
      return `${(size / 1024).toFixed(1)} KB`
    },
    getDownloadUrl(file) {
      return _.get(file, 'original_url') || _.get(file, 'url') || null
    },
    removeAttachment(idx){
      if(this.dataForm && this.dataForm.id && this.generalAttachments[idx].id){
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remover anexo',
          acceptText: 'Sim',
          cancelText: 'Nao',
          text: 'Tem certeza que deseja remover este anexo? Esta acao nao podera ser desfeita.',
          accept: () => this.removeAttachmentPersist(idx)
        })
      }else{
        this.generalAttachments.splice(idx, 1)
      }
    },
    removeAttachmentPersist(idx){
      this.$vs.loading()
      this.services.requestFormIncidentService.deleteFile(this.dataForm.id, this.generalAttachments[idx].id).then(
          () => {
            this.notifySuccess(this.$vs, 'Anexo removido com sucesso!', 4000, 'top-center')
            this.generalAttachments.splice(idx, 1)
          }
        ).finally(() => {
          this.$vs.loading.close()
        })
    },
    getData(id) {
      this.$vs.loading()
      this.services.requestFormIncidentHandlingService.read(id).then(
        dataHandling => {
          this.dataForm = dataHandling.form;
          this.generalAttachments = _.get(dataHandling, 'form.general_attachments', []) || []
        },
        error => {
        }
      ).finally(() => {
        this.$vs.loading.close()
      })
    },
    clearFields() {
      this.dataForm = null
      this.generalAttachments = []
      this.newGeneralAttachments = []
      if (this.$refs.coupAttempt) {
        this.$refs.coupAttempt.clearFields()
      }
      if (this.$refs.general) {
        this.$refs.general.clearFields()
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    sucessNotify() {
      this.$vs.notify({
        title: 'Successo!',
        text: 'Operação realizada com sucesso.',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-check-circle'
      })
      this.scrollToTop()
    },
  },
  computed: {
    validateForm() {
      return true
    },
    typeForm() {
      return (this.dataForm && this.dataForm.type_form)? this.dataForm.type_form : 'GE'
    },
    legalEntityId() {
      return (this.dataForm && this.dataForm.legal_entity_origin_id)? this.dataForm.legal_entity_origin_id : null
    },
    disabledFields() {
      if(this.dataForm && this.dataForm.id){
        if(this.dataForm.status === 'DR' || this.dataForm.status === 'RC'){
          return false
        }else{
          return true
        }
      }
      return false
    }
  },
  mounted() {
    //this.$vs.loading.close()
    if (this.id) {
      this.getData(this.id)
    }
  },
  beforeMount() {
    //this.$vs.loading()
    const promisses = []

    this.services.requestFormIncidentService = RequestFormIncidentService.build(this.$vs)
    this.services.requestFormIncidentHandlingService = RequestFormIncidentHandlingService.build(this.$vs)

    promisses.push(

    )
  }
}
</script>
